import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import {
  ScheduleService,
  TimemanagerDialogService,
} from '../../../../../../../../features/timemanager/services';
import { HeatingPanelService } from '../../heating-panel.service';

@Component({
  selector: 'app-mfh-programs-panel',
  templateUrl: './mfh-programs-panel.component.html',
  styleUrls: ['./mfh-programs-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MfhProgramsPanelComponent {
  @Input() activeTabIndex: number;
  @Input() circuitId: string;

  constructor(
    public timemanagerDialogService: TimemanagerDialogService,
    public heatingPanelService: HeatingPanelService,
    public scheduleService: ScheduleService
  ) {}
}
